import { setToken, removeToken, getToken } from "@/utils/cookie";
import {
    setLocalStore,
    getLocalStore,
    setSessionStore,
    encodeStr,
    goHome
} from "@/utils";

const user = {
    state: {
        // 用户信息
        userInfo: null,
        isLogin: getLocalStore("certificate") ? true : false,
        lang: getLocalStore("lang"),
        currencyData: [
            { name: "ETH", img: require("@/assets/images/coin/icon_eth.svg"), openwork: require("@/assets/images/coin/icon_eth_openwork.svg"), val: "ETH" },
            { name: "ETC", img: require("@/assets/images/coin/icon_etc.svg"), openwork: require("@/assets/images/coin/icon_etc_openwork.svg"), val: "ETC" },
            { name: "ETHF", img: require("@/assets/images/coin/icon_ethf.svg"), openwork: require("@/assets/images/coin/icon_ethf_openwork.svg"), val: "ETHF" },
            { name: "ETHW", img: require("@/assets/images/coin/icon_ethw.svg"), openwork: require("@/assets/images/coin/icon_ethw_openwork.svg"), val: "ETHW" },
            { name: "XCH", img: require("@/assets/images/coin/icon_xch.svg"), openwork: require("@/assets/images/coin/icon_xch_openwork.svg"), val: "XCH" },
            // { name: "RVN", img: require("@/assets/images/coin/icon_rvn.svg"), openwork: require("@/assets/images/coin/icon_rvn_openwork.svg"), val: "RVN" },
            { name: "PINK", img: require("@/assets/images/coin/icon_pink.svg"), openwork: require("@/assets/images/coin/icon_pink_openwork.svg"), val: "PINK" },
            { name: "POM", img: require("@/assets/images/coin/icon_pom.svg"), openwork: require("@/assets/images/coin/icon_pom_openwork.svg"), val: "POM" },
            { name: "ALEO", img: require("@/assets/images/coin/icon_aleo.svg"), openwork: require("@/assets/images/coin/icon_aleo_openwork.svg"), val: "ALEO" },
        ],
        miningTechnology: 1, // 1:自研币种，2：中转币种
        accountName: null,
        miningType: "", //挖矿币种
        searchCoin: "", //筛选币种
        walletAddr: null, //挖矿地址
        showCoin: false, //是否显示筛选币种下拉
        showModify: false, //是否显示修改密码弹窗
        // token通证
        tokenInfo: {
            ucTicket: "",
            ucToken: "",
            poolToken: "",
            certificate: ""
        },
        // 底部区域
        showFootBar: true
    },
    mutations: {
        SET_USER_INFO(state, payload) {
            setLocalStore("userInfo", encodeStr(JSON.stringify(payload)));
            state.userInfo = payload;
        },
        SET_MINING_TECHNOLOGY(state, payload) {
            setLocalStore("miningTechnology", payload);
            state.miningTechnology = payload;
        },
        SET_ACCOUNT_NAME(state, payload) {
            if (!payload) {
                window.sessionStorage.removeItem('accountName');
                state.accountName = null;
                return
            }
            setSessionStore("accountName", payload);
            state.accountName = payload;
        },
        SET_MINING_TYPE(state, payload) {
            if (!payload) {
                window.sessionStorage.removeItem('miningType');
                state.miningType = null;
                return
            }
            setSessionStore("miningType", payload);
            state.miningType = payload;
        },
        SET_SEARCH_COIN(state, payload) {
            setSessionStore("searchCoin", payload);
            state.searchCoin = payload;
        },
        SET_SHOW_COIN(state, payload) {
            setSessionStore("showCoin", payload);
            state.showCoin = payload;
        },
        SET_SHOW_MODIFY(state, payload) {
            setSessionStore("showModify", payload);
            state.showModify = payload;
        },
        SET_WALLET_ADDR(state, payload) {
            if (!payload) {
                window.sessionStorage.removeItem('walletAddr');
                state.walletAddr = null;
                return
            }
            setSessionStore("walletAddr", payload);
            state.walletAddr = payload;
        },

        SET_CURRENCY_DATA(state, payload) {
            setSessionStore("currencyData", encodeStr(JSON.stringify(payload)));
            state.currencyData = payload;
        },

        SET_TOKEN_INFO(state, payload) {
            const { certificate } = payload;
            if (certificate) {
                setLocalStore("certificate", certificate);
                setToken("certificate", certificate);
            }
            state.tokenInfo = Object.assign({}, state.tokenInfo, payload);
            state.isLogin = true;
        },

        SET_LOGIN_STATUS(state, payload) {
            state.isLogin = payload;
        },

        SET_FOOT_STATUS(state, payload) {
            state.showFootBar = payload;
        }
    },
    actions: {
        // 设置用户信息
        setUserInfo({ commit }, payload) {
            commit("SET_USER_INFO", payload);
        },

        // 设置挖矿技术
        setMiningTechnology({ commit }, payload) {
            commit("SET_MINING_TECHNOLOGY", payload);
        },

        // 设置币种列表
        setCurrencyData({ commit }, payload) {
            commit("SET_CURRENCY_DATA", payload);
        },

        // 设置当前子账号名称
        setAccountName({ commit }, payload) {
            commit("SET_ACCOUNT_NAME", payload);
        },

        // 设置当前挖矿币种
        setMiningType({ commit }, payload) {
            commit("SET_MINING_TYPE", payload);
        },

        // 设置当前筛选币种
        setSearchCoin({ commit }, payload) {
            commit("SET_SEARCH_COIN", payload);
        },
        // 设置是否显示筛选币种
        setShowCoin({ commit }, payload) {
            commit("SET_SHOW_COIN", payload);
        },
        // 设置是否显示修改密码弹窗
        setShowModify({ commit }, payload) {
            commit("SET_SHOW_MODIFY", payload);
        },
        // 设置当前挖矿地址
        setWalletAddr({ commit }, payload) {
            commit("SET_WALLET_ADDR", payload);
        },

        // 退出登录
        async logOut({ commit }, noRedict) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            // const outRes = await ApiUser.logout();

            // 临时存储
            const lang = localStorage.getItem("lang");
            const searchs = localStorage.getItem("_search_");
            const activeInfo = localStorage.getItem("activeInfo");


            localStorage.clear();
            if (lang) localStorage.setItem("lang", lang);
            if (searchs) localStorage.setItem("_search_", searchs);
            if (activeInfo) localStorage.setItem("activeInfo", activeInfo);
            removeToken("certificate");
            commit("SET_USER_INFO", null);
            commit("SET_LOGIN_STATUS", false);
            if (!noRedict)
                setTimeout(() => {
                    goHome();
                }, 500);
        },

        // 更新底部状态
        updateFootStatus({ commit }, payload) {
            commit("SET_FOOT_STATUS", payload);
        }
    }
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js